export default "__VITE_ASSET__SBTcmd80__"